"use client";

import { useLocale } from "@i18n/next";
import {
  keyCommunitiesAdminCommunities,
  keyCommunitiesAdminCommunity,
  keyMe,
  useQueryClient,
} from "@packages/sdk";

import { KEY_COMMUNITIES_ADMIN_USERS_BASE } from "../useRequestCommunitiesAdminUsers";

export const useInvalidateCommunityQueries = ({ id }: { id: number }) => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey
            .flat()
            .some((keyPart) => keyPart === KEY_COMMUNITIES_ADMIN_USERS_BASE),
      }),

      /** Legacy invalidations */
      await queryClient.invalidateQueries({
        queryKey: [keyCommunitiesAdminCommunity({ id }), locale],
      }),
      await queryClient.invalidateQueries({
        queryKey: [keyCommunitiesAdminCommunities(), locale],
      }),
      await queryClient.invalidateQueries({ queryKey: [keyMe(), locale] }),
    ]);
  };
};
